import {Col, Row} from "react-bootstrap";
import {useEffect, useState} from "react";
import HttpRequest from "../../../Common/Http/HttpRequest";
import Notify from "../../../Common/Notify/Notify";
import {EstouPronto} from "./EstouPronto";
import {ComeceATrabalhar} from "./ComeceATrabalhar";

export const ApontarHorasDireta = () => {

    const [horasAbertas, setHorasAbertas] = useState([]);

    const [projetos, setProjetos] = useState([]);

    const [ultimosJobs, setultimosJobs] = useState({
        jobs: [],
        duration: 'Carregando...'
    });

    useEffect(() => {
        loadOpenedEvents();
        loadProjects();
        loadLastJobs();
    }, [])

    const loadOpenedEvents = () => {
        HttpRequest.get(`${process.env.REACT_APP_NODE_SERVICE}/crud/entity/cflow_work_times?endDate=`).then(horasAbertas => {
            setHorasAbertas(horasAbertas.data);
        });
    }

    const loadLastJobs = () => {
        const mesAtual = new Date();
        mesAtual.setDate(1);
        mesAtual.setHours(0);
        mesAtual.setMinutes(0)
        mesAtual.setSeconds(0);
        mesAtual.setMilliseconds(0);


        HttpRequest.get(`${process.env.REACT_APP_NODE_SERVICE}/crud/entity/cflow_work_times?size=9000&startDate_gt=${mesAtual.toISOString()}`).then(lastJObs => {
            const jobs = lastJObs.data;

            let duration = 0;
            jobs.forEach(job => {
                duration += (job.endDate ? new Date(job.endDate) : new Date()) - new Date(job.startTime);
            })

            const horas = Math.floor(duration / (1000 * 60 * 60));
            const minutos = Math.floor((duration % (1000 * 60 * 60)) / (1000 * 60));

            setultimosJobs({
                jobs,
                duration: `${String(horas).padStart(2, '0')}:${String(minutos).padStart(2, '0')}`
            });
        });
    }

    const loadProjects = () => {
        HttpRequest.get(`${process.env.REACT_APP_NODE_SERVICE}/crud/entity/cflow_projects`).then(cflowProjects => {
            setProjetos(cflowProjects.data);
        });
    }

    const onEventUpdated = () => {
        loadOpenedEvents();
        loadProjects();
        loadLastJobs();
    }

    return (
        <>
            <Row>
                <Col>
                    <h5> Trabalho atual</h5>
                    <ul>

                        {horasAbertas.map(x => {
                            return <EstouPronto key={x.id} row={x} onEventUpdated={onEventUpdated}/>
                        })}

                        {horasAbertas.length == 0 &&
                            <h5 className="mt-4"> Sem apontamentos, não esqueça de iniciar seu apontamento para um
                                projeto</h5>}

                    </ul>
                </Col>
            </Row>
            <hr/>

            <Row>
                <Col>
                    <h5><b>Tempo atual trabalhado: </b> {ultimosJobs.duration}</h5>
                </Col>
            </Row>

            <hr/>
            <Row>
                {projetos.map(x => {
                    return <ComeceATrabalhar key={x.id} row={x} onEventUpdated={onEventUpdated}/>
                })}
            </Row>
        </>
    )
}
